/**
 * @ngdoc directive
 * @name directiveRaceCourse
 * @restrict A
 *
 * @description
 * Directive for raceCourse block
 *
 * @element ANY
 */
export default function () {
    return {
        restrict: 'A', // Only element attribute can be used for directive definition
        controller: 'DirectiveRaceCourseCtrl' // Executes before compile
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/raceCourse.js